document.addEventListener('DOMContentLoaded', function() {
    const checkboxes = document.querySelectorAll('.variant--quick__add-button input[type="checkbox"]');
  
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                checkboxes.forEach(otherCheckbox => {
                if (otherCheckbox !== this) {
                    otherCheckbox.checked = false;
                    const otherParentDiv = otherCheckbox.closest('.variant--quick__add-button');
                    otherParentDiv.classList.remove('checked');
                }
                });
                const parentDiv = this.closest('.variant--quick__add-button');
                parentDiv.classList.add('checked');
            } else {
                const parentDiv = this.closest('.variant--quick__add-button');
                parentDiv.classList.remove('checked');
            }
        });
    });

    const cardSliderButtons =  document.querySelectorAll('[id^="swiper-button-"]');
    cardSliderButtons.forEach((button) => {
        let variantsProductCard = document.querySelector(`#${button.dataset.card} .quick-add__variants`);
        button.addEventListener("mouseover" , () => {
            console.log('Mouse in');
            variantsProductCard.style.opacity = "0";
            variantsProductCard.style.zIndex = "-1";
        })
        button.addEventListener("mouseout" , () => {
            console.log('Mouse out');
            variantsProductCard.style.opacity = "";
            variantsProductCard.style.zIndex = "";
        })
    })
  
    // Select the element to observe for changes
    const activeFacets = document.querySelector('.active-facets');

    if(activeFacets){
      // Configure the observer to watch for changes in child nodes
      const observer = new MutationObserver((mutationsList) => {
        // Iterate over the mutations recorded
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // If a change in child nodes is detected
            if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
              console.log('Changes detected in child nodes.');
              location.reload();
            }
          }
        }
      });
      
      // Observer options to watch for changes in child nodes
      const config = { childList: true, subtree: true };
      
      // Start observing the element
      observer.observe(activeFacets, config);
      
      // Example of how to stop observing if it's no longer needed
      // observer.disconnect();
    }
});


/*DESPLAZAMIENTO PAGO*/
document.addEventListener("DOMContentLoaded", function () {
    const cartFooter = document.getElementById("main-cart-footer");
    if (!cartFooter) return;
  
    const movil = window.innerWidth <= 550; // Verifica si es móvil
    const triggerBlock = document.querySelector(".newsletter");
    if(movil){
      const triggerBlock = document.querySelector(".footer");
    }
    
    let isFixed = false;

    function handleScroll() {
      const scrollY = window.scrollY + (window.innerHeight);
      const triggerPosition = triggerBlock.offsetTop + triggerBlock.offsetHeight;

      console.log("objetivo: " , triggerPosition);
      console.log("Posicion actual: " , scrollY);

      if (scrollY >= triggerPosition && isFixed) {//objetivo alcanzado
          cartFooter.style.transform = "translateX(100%)";

          setTimeout(() => {
            if(movil){
              cartFooter.style.display = "none";
            }
            
            cartFooter.style.position = "static";
            cartFooter.style.transform = "translateX(0%)";
          }, 400);
        
          isFixed = false;

      } else if (scrollY < triggerPosition && !isFixed) {//fijar bloque
          console.log("Bloque fijado");
                  
          cartFooter.style.display = "none";
          cartFooter.style.transform = "translateX(100%)";
          cartFooter.style.position = "fixed";

          setTimeout(()=>{
            cartFooter.style.display = "block";
          }, 400);

          setTimeout(()=>{
            cartFooter.style.transform = "translateX(0%)";
          }, 500);
                    
          isFixed = true;
      }
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();
});